import {
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS,
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED,
  CLEAR_IMPORT_UPLOAD,
  CREATE_SEGMENT_FAILED,
  CREATE_SEGMENT_SUCCESS,
  CREATE_SEGMENT_WATCHER,
  DELETE_SEGMENT_FAILED,
  DELETE_SEGMENT_SUCCESS,
  DELETE_SEGMENT_WATCHER,
  GET_GROUPS_FAILED,
  GET_GROUPS_SUCCESS,
  GET_GROUPS_WATCHER,
  GET_SEGMENTS_FAILED,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_WATCHER,
  GET_VARIABLES_FAILED,
  GET_VARIABLES_SUCCESS,
  GET_VARIABLES_WATCHER,
  UPDATE_SEGMENT_FAILED,
  UPDATE_SEGMENT_SUCCESS,
  UPDATE_SEGMENT_WATCHER,
} from "./constants"

export function getVariablesWatcher(payload) {
  return {
    type: GET_VARIABLES_WATCHER,
    payload,
  }
}

export function getVariablesSuccess(payload) {
  return {
    type: GET_VARIABLES_SUCCESS,
    payload,
  }
}

export function getVariablesFailed(payload) {
  return {
    type: GET_VARIABLES_FAILED,
    payload,
  }
}

export function getGroupsWatcher(payload) {
  return {
    type: GET_GROUPS_WATCHER,
    payload,
  }
}

export function getGroupsSuccess(payload) {
  return {
    type: GET_GROUPS_SUCCESS,
    payload,
  }
}

export function getGroupsFailed(payload) {
  return {
    type: GET_GROUPS_FAILED,
    payload,
  }
}

export function createSegmentWatcher(payload) {
  return {
    type: CREATE_SEGMENT_WATCHER,
    payload,
  }
}

export function createSegmentSuccess(payload) {
  return {
    type: CREATE_SEGMENT_SUCCESS,
    payload,
  }
}

export function createSegmentFailed(payload) {
  return {
    type: CREATE_SEGMENT_FAILED,
    payload,
  }
}

export function updateSegmentWatcher(payload) {
  return {
    type: UPDATE_SEGMENT_WATCHER,
    payload,
  }
}

export function updateSegmentSuccess(payload) {
  return {
    type: UPDATE_SEGMENT_SUCCESS,
    payload,
  }
}

export function updateSegmentFailed(payload) {
  return {
    type: UPDATE_SEGMENT_FAILED,
    payload,
  }
}

export function deleteSegmentWatcher(payload) {
  return {
    type: DELETE_SEGMENT_WATCHER,
    payload,
  }
}

export function deleteSegmentSuccess(payload) {
  return {
    type: DELETE_SEGMENT_SUCCESS,
    payload,
  }
}

export function deleteSegmentFailed(payload) {
  return {
    type: DELETE_SEGMENT_FAILED,
    payload,
  }
}

export function getSegmentsWatcher(payload) {
  return {
    type: GET_SEGMENTS_WATCHER,
    payload,
  }
}

export function getSegmentsSuccess(payload) {
  return {
    type: GET_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getSegmentsFailed(payload) {
  return {
    type: GET_SEGMENTS_FAILED,
    payload,
  }
}
// GET EXCEL
export function getTemplateSegmentCollaboratorsWatcher(payload) {
  return {
    type: GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
    payload,
  }
}
export function getTemplateSegmentCollaboratorsSuccess(payload) {
  return {
    type: GET_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS,
    payload,
  }
}
export function getTemplateSegmentCollaboratorsFailed(payload) {
  return {
    type: GET_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED,
    payload,
  }
}

// UPLOAD EXCEL
export function uploadTemplateSegmentCollaboratorsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
    payload,
  }
}

export function uploadTemplateSegmentCollaboratorsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function uploadTemplateSegmentCollaboratorsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED,
    payload,
  }
}
export function clearImportUpload() {
  return {
    type: CLEAR_IMPORT_UPLOAD,
  }
}
